import { Component, OnInit, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { RestService } from 'src/app/services/rest.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnInit {
  public event: EventEmitter<any> = new EventEmitter();

  fileText: any = "";
  // fileText: any = "Choose file";

  isButtonDisabled: boolean = false;
  fileToUpload: File = null;
  fileWithFormData: FormData;
  returnFileData: any;

  constructor(
    private restService: RestService,
    private bsModalRef: BsModalRef,
  ) { }

  ngOnInit() { }

  handleFileInput(file) {
    var files: FileList = file;
    this.fileToUpload = files.item(0);
    this.fileText = this.fileToUpload.name;
    this.fileWithFormData = new FormData();
    this.fileWithFormData.set('file', this.fileToUpload, this.fileToUpload.name);
    // this.uploadFileToActivity();
  }

  uploadFileToActivity() {
    this.isButtonDisabled = true;
    this.restService.postFile('/api/files', this.fileWithFormData).subscribe(data => {
      this.isButtonDisabled = false;
      console.log(data)
      this.returnFileData = data;
      this.cancel();
    }, error => {
      this.isButtonDisabled = false;
      console.log(error);
    });
  }

  cancel(): void {
    if(this.returnFileData){
      this.event.emit(this.returnFileData);
    }

    this.bsModalRef.hide();
  }
}
